<template>
  <div class="mb-2" v-if="hasManagers">
    <h3 class="fs-6 my-0">RESPONSABLE(S)</h3>
    <p class="low-text text-muted mb-0">{{ getFirstManagerFullName }}</p>
    <a class="fw-light mb-2 text-break" v-if="getManagerEmailAddress" :href="'mailto:' + getManagerEmailAddress">
      <i class="fa fa-envelope"></i> {{ getManagerEmailAddress }}
    </a>
  </div>

  <div v-if="hasContacts">
    <h3 class="fs-6 my-0">CONTACT(S)</h3>
    <p class="low-text text-muted mb-0">{{ getFirstContactFullName }}</p>
    <a class="fw-light mb-2 text-break" v-if="getContactEmailAddress" :href="'mailto:' + getContactEmailAddress">
      <i class="fa fa-envelope"></i> {{ getContactEmailAddress }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'PartnerContacts',
  props: {
    contacts: Object
  },

  computed: {
    hasManagers() {
      return this.contacts.managers.length > 0;
    },

    isCustomManagerType() {
      return this.contacts.managers[0].type === 'Personnalisé'
    },

    isCustomContactType() {
      return this.contacts.contacts[0].type === 'Personnalisé'
    },

    hasContacts() {
      return this.contacts.contacts.length > 0;
    },

    getFirstManagerFullName() {
      if (this.isCustomManagerType === true) {
        return [this.contacts.managers[0].firstname, this.contacts.managers[0].lastname].join(' ');
      }

      return [this.contacts.managers[0].account.user_firstname, this.contacts.managers[0].account.user_lastname].join(' ');
    },

    getFirstContactFullName() {
      if (this.isCustomContactType === true) {
        return [this.contacts.contacts[0].firstname, this.contacts.contacts[0].lastname].join(' ');
      }

      return [this.contacts.contacts[0].account.user_firstname, this.contacts.contacts[0].account.user_lastname].join(' ');
    },

    getManagerEmailAddress() {
      if (this.isCustomManagerType === true) {
        return this.contacts.managers[0].email_address;
      }

      return this.contacts.managers[0].account.user_email;
    },

    getContactEmailAddress() {
      if (this.isCustomContactType === true) {
        return this.contacts.contacts[0].email_address;
      }

      return this.contacts.contacts[0].account.user_email;
    }
  }
}
</script>

<style scoped>
.low-text {
  font-size: 0.875rem;
}
</style>
